import { createContext, useContext } from 'react';
import type { ActingAsEntity } from '../../../v2/js/utils/actingAsEntity';
import type { useCurrentUser } from '../hooks/auth';

export type SessionContextType = Partial<ReturnType<typeof useCurrentUser>> & {
  sessionExists?: boolean;
  setSessionExists: () => void; // No longer takes a boolean parameter
  logout?: () => void;
  audience?: 'provider' | 'healthcare_entity' | 'staff' | undefined;
  audienceIsProvider?: boolean;
  audienceIsOrg?: boolean;
  audienceIsStaff?: boolean;
  currentEntity?: string;
  actingAsEntity?: ActingAsEntity | null;
  setActingAsEntity?: (entity: ActingAsEntity | null) => void;
};

export const SessionContext = createContext<SessionContextType>({
  sessionExists: false,
  setSessionExists: () => {},
  logout: async () => {},
  audience: undefined,
  audienceIsProvider: false,
  audienceIsOrg: false,
  audienceIsStaff: false,
  currentEntity: undefined,
  actingAsEntity: null,
  setActingAsEntity: () => {},
});

export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within a Session provider');
  }
  return context;
};
